var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"player"},[_c('vueAplayer',{key:_vm.currentMusicItem.src,ref:"MusicPlayer",attrs:{"music":_vm.currentMusicItem,"list":_vm.musicList,"showLrc":true,"mutex":false,"volume":0.5,"listMaxHeight":"0px","list-folded":true},on:{"error":_vm.onError,"ended":_vm.onEnded}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }